import styled, { css } from "styled-components";

export const TextWrapper = styled.div`
  ${({ justify, textIndent }) => css`
    padding: 0.5rem 0;
    text-align: ${justify ? "justify" : "center"};

    li {
      list-style-position: inside;
      margin-bottom: 0.5rem;
      padding-left: 2em;
      text-indent: -1.3em;
    }

    p {
      text-align: ${justify ? "justify" : "left"};
      text-indent: ${textIndent ?? "1.5rem"};
    }
  `}
`;
